'use strict';

// Constant values. Some are overridden as part of the deployment process.

var config = angular.module('chatEngine.configuration', []);

// Constants
config.constant('SHARE_URL', 'https://dev.kik.com/');
config.constant('BOTSWORTH_USERNAME', 'botsworth.staging');
config.constant('KIK_ENGINE_KEY', 'session');

// Enums
config.constant('ACCESS_LEVELS', ['None', 'Viewer', 'Editor', 'Creator', 'Admin']);
config.constant('HEALTH_FLAGS', {
    GREEN: 0,
    YELLOW: 1,
    RED: 2
});
config.constant('PROFILE_PIC_URL_PREFIXES', {
    HTTP_BARE: 'http://profilepics.kik.com/',
    HTTP_CF: 'http://profilepics.cf.kik.com/',
    HTTPS: 'https://profilepics.cf.kik.com/'
});
config.constant('TOS_MAP', {
    '0': 'UNKNOWN',
    '1': 'DECLINED',
    '2': 'ACCEPTED'
});

// Limitations
config.constant('LISTING_BYLINE_MAX_LENGTH', 40);
config.constant('LISTING_DESCRIPTION_MAX_LENGTH', 4000);
config.constant('LISTING_FEATURED_BANNER_WIDTH', 1920);
config.constant('LISTING_FEATURED_BANNER_HEIGHT', 1080);
config.constant('LISTING_PROFILE_BANNER_WIDTH', 1280);
config.constant('LISTING_PROFILE_BANNER_HEIGHT', 720);
config.constant('MAX_ADMINS_PER_BOT', 10);
config.constant('SUBMIT_BOT_NOTES_MAX_LENGTH', 400);

// Regular Expressions
config.constant('DEBUG', (/^http:\/\/(127\.0\.0\.1)|(localhost)|(0\.0\.0\.0)/).test(window.location.href));
// source: https://gist.github.com/dperini/729294
config.constant('URL_REGEX', /^(?:(?:https?):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:\/\S*)?$/i); // jscs:ignore
config.constant('USERNAME_REGEX', /^[\w\.]{2,30}$/);
config.constant('DISPLAY_NAME_REGEX', /^.{1,32}$/);

// Secrets
config.constant('MIXPANEL_TOKEN', '5655534fd839e756b5795dc728deaeda');
config.constant('FIREBASE_API_KEY', 'AIzaSyANmJOBkqzqC5QB1JA-BfuDC_If1Wx3qA4');
config.constant('FIREBASE_AUTH_DOMAIN', 'bot-dashboard-staging-1.firebaseapp.com');
config.constant('FIREBASE_DATABASE_URL', 'https://bot-dashboard-staging-1.firebaseio.com');
config.constant('FIREBASE_STORAGE_BUCKET', 'bot-dashboard-staging-1.appspot.com');
config.constant('FIREBASE_MESSAGING_SENDER_ID', '124880067809');

// Values for campaigns (must match the backend)
config.constant('MALE', 1);
config.constant('FEMALE', 2);
config.constant('ANDROID', 1);
config.constant('IOS', 2);
